<template>
    <SideHeader :to="'/'" />
    <div>
        <ListView v-if="loading" />

        <div v-else class="form-box">
            <!-- انتخاب مبدا و مقصد -->
            <div class="form-group basic">
                <div class="input-wrapper d-flex flex-column" ref="dropdownContainerFrom">
                    <label for="origin">مبدا</label>

                    <div class="input-group" dir="ltr">
                        <input type="text" v-model="searchFrom" @input="filterOptionsFrom" dir="rtl"
                            @keydown.enter="this.showDropdownFrom = false" :placeholder="placeholderTextFrom"
                            class="form-control form-select mb-1" @click="toggleDropdownFrom" />
                    </div>
                    <div class="dropdown">
                        <ul v-if="showDropdownFrom" class="dropdown-menu show dropdown-scroll">
                            <li v-for="option in filteredOptionsFrom" :key="option.value"
                                @click="selectOptionFrom(option)" class="dropdown-item">
                                {{ option.name }} - {{ option.state }}
                            </li>
                        </ul>
                    </div>
                </div>
                <p v-show="errors.fromLoad" class="text-danger text-center">{{ errors.fromLoad }}</p>
            </div>
            <div class="form-group basic">
                <div class="input-wrapper" ref="dropdownContainerTo">
                    <label for="origin">مقصد</label>
                    <div class="input-group" dir="ltr">

                        <input type="text" v-model="searchTo" @input="filterOptionsTo" dir="rtl"
                            placeholder="مقصد مورد نظر..." class="form-control form-select mb-1"
                            aria-label="basic-addon1" aria-describedby="basic-addon1" @click="toggleDropdownTo" />
                    </div>
                    <div class="dropdown">
                        <ul v-if="showDropdownTo" class="dropdown-menu show dropdown-scroll">
                            <li v-for="option in filteredOptionsTo" :key="option.id" @click="selectOptionTo(option)"
                                class="dropdown-item">
                                {{ option.name }} - {{ option.state }}
                            </li>
                        </ul>
                    </div>
                    <p v-show="errors.toLoad" class="text-danger text-center">{{ errors.toLoad }}</p>

                </div>
            </div>

            <!-- انتخاب ماشین و بارگیر -->
            <div class="mb-3">
                <div class="form-group basic" @click="backFleet()">
                    <div class="input-wrapper">
                        <label for="origin">نوع ناوگان</label>
                        <span class="form-control form-select mt-1 text-start" data-bs-toggle="offcanvas"
                            data-bs-target="#actionSheetForm" href="#">{{ selectedState }}</span>
                        <i class="clear-input">
                            <ion-icon name="close-circle"></ion-icon>
                        </i>
                    </div>
                </div>
            </div>
            <!-- دکمه -->
            <button type="button" class="btn btn-custom" @click="calculatePrice">
                محاسبه کرایه حمل بار
            </button>
            <div class="offcanvas offcanvas-bottom action-sheet" tabindex="-1" id="actionSheetForm">
                <div class="offcanvas-header background-TEAL">
                    <h5 class="offcanvas-title text-light">انتخاب ناوگان</h5>
                    <a href="#" id="backFleet" class="offcanvas-close" style="display: none"
                        data-bs-dismiss="offcanvas">
                        <ion-icon name="close-outline"></ion-icon>
                    </a>
                </div>
                <div class="offcanvas-body">
                    <div class="form-group basic mb-5">
                        <div class="input-wrapper">
                            <div class="section full mt-2">
                                <div class="section-title" style="justify-content: center !important;">لطفا
                                    ناوگان مورد نظر
                                    خود را انتخاب کنید</div>

                                <div class="accordion" id="accordionExample1">
                                    <div class="accordion-item">
                                        <h2 class="accordion-header">
                                            <button class="accordion-button collapsed" type="button"
                                                data-bs-toggle="collapse" data-bs-target="#accordion5">
                                                نیسان و وانت
                                            </button>
                                        </h2>
                                        <div id="accordion5" class="accordion-collapse collapse"
                                            data-bs-parent="#accordionExample1">
                                            <div class="accordion-body">
                                                <div class="input-list">
                                                    <div class="form-check" v-for="fleet in fleets.coms5"
                                                        :key="fleet.id">
                                                        <input class="form-check-input" type="radio" name="radioList"
                                                            :value="fleet.id" :id="'radioList' + fleet.id"
                                                            v-model="postData.fleetId"
                                                            @click="changeTitleFleet(fleet.title)">
                                                        <label class="form-check-label" :for="'radioList' + fleet.id">{{
        fleet.title
    }}</label>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="accordion-item">
                                        <h2 class="accordion-header">
                                            <button class="accordion-button collapsed" type="button"
                                                data-bs-toggle="collapse" data-bs-target="#accordion1">
                                                کامیونت
                                            </button>
                                        </h2>
                                        <div id="accordion1" class="accordion-collapse collapse"
                                            data-bs-parent="#accordionExample1">
                                            <div class="accordion-body">
                                                <div class="input-list">

                                                    <div class="form-check" v-for="fleet in fleets.coms1"
                                                        :key="fleet.id">
                                                        <input class="form-check-input" :value="fleet.id" type="radio"
                                                            name="radioList" @click="changeTitleFleet(fleet.title)"
                                                            :id="'radioList' + fleet.id" v-model="postData.fleetId">
                                                        <label class="form-check-label" :for="'radioList' + fleet.id">
                                                            {{ fleet.title }}</label>
                                                    </div>

                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="accordion-item">
                                        <h2 class="accordion-header">
                                            <button class="accordion-button collapsed" type="button"
                                                data-bs-toggle="collapse" data-bs-target="#accordion2">
                                                کامیون 6 چرخ (تک)
                                            </button>
                                        </h2>
                                        <div id="accordion2" class="accordion-collapse collapse"
                                            data-bs-parent="#accordionExample1">
                                            <div class="accordion-body">
                                                <div class="input-list">
                                                    <div class="form-check" v-for="fleet in fleets.coms2"
                                                        :key="fleet.id">
                                                        <input class="form-check-input" type="radio" name="radioList"
                                                            :value="fleet.id" @click="changeTitleFleet(fleet.title)"
                                                            :id="'radioList' + fleet.id" v-model="postData.fleetId">
                                                        <label class="form-check-label" :for="'radioList' + fleet.id">
                                                            {{ fleet.title }}</label>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="accordion-item">
                                        <h2 class="accordion-header">
                                            <button class="accordion-button collapsed" type="button"
                                                data-bs-toggle="collapse" data-bs-target="#accordion3">
                                                کامیون 10 چرخ (جفت)
                                            </button>
                                        </h2>
                                        <div id="accordion3" class="accordion-collapse collapse"
                                            data-bs-parent="#accordionExample1">
                                            <div class="accordion-body">
                                                <div class="input-list">
                                                    <div class="form-check" v-for="fleet in fleets.coms3"
                                                        :key="fleet.id">
                                                        <input class="form-check-input" type="radio" name="radioList"
                                                            :value="fleet.id" @click="changeTitleFleet(fleet.title)"
                                                            :id="'radioList' + fleet.id" v-model="postData.fleetId">
                                                        <label class="form-check-label" :for="'radioList' + fleet.id">
                                                            {{ fleet.title }}
                                                        </label>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="accordion-item">
                                        <h2 class="accordion-header">
                                            <button class="accordion-button collapsed" type="button"
                                                data-bs-toggle="collapse" data-bs-target="#accordion4">
                                                تریلی
                                            </button>
                                        </h2>
                                        <div id="accordion4" class="accordion-collapse collapse"
                                            data-bs-parent="#accordionExample1">
                                            <div class="accordion-body">
                                                <div class="input-list">
                                                    <div class="form-check" v-for="fleet in fleets.coms4"
                                                        :key="fleet.id">
                                                        <input class="form-check-input" type="radio" name="radioList"
                                                            :value="fleet.id" :id="'radioList' + fleet.id"
                                                            v-model="postData.fleetId"
                                                            @click="changeTitleFleet(fleet.title)">
                                                        <label class="form-check-label" :for="'radioList' + fleet.id">{{
                                                            fleet.title }}</label>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="form-group basic" style=" position: fixed; bottom: 0;">
                        <button type="button" data-bs-dismiss="offcanvas"
                            class="btn background-ORANGE text-light btn-block">
                            ثبت
                        </button>
                    </div>
                </div>
            </div>
            <div class="card mt-2">
                <div class="card-header background-TEAL text-light text-center">کرایه پیشنهادی</div>
                <div class="card-body text-center">
                    {{ this.price }}
                </div>
            </div>
        </div>
    </div>


</template>
<script>
import ListView from '@/components/Placeholder/ListView.vue';
import SideHeader from '@/components/SideHeader.vue';
import router from '@/router';
import axios from 'axios';
// import { debounce } from "lodash";
import Swal from 'sweetalert2';

export default {
    components: {
        SideHeader,
        ListView
    },
    data() {
        return {
            searchQuery: "",
            origin: "",
            searchTo: '',
            destination: "",
            price: 'لطفا اطلاعات پر کنید',
            // vehicle: "",
            // loader: "",
            showDropdownFrom: false,
            showDropdownTo: false,
            loading: true,
            selectedState: 'انتخاب کنید',
            optionsTo: [],
            selectedFrom: null,
            searchFrom: '',
            filteredOptionsTo: [],
            optionsFrom: [],
            filteredOptionsFrom: [],
            placeholderTextFrom: 'مبدا مورد نظر ...',
            postData: {
                fromCityId: "",
                toCityId: "",
                fleetId: "",
            },

            errors: {
                fromLoad: '',
                toLoad: '',
                fleet: '',
                // suggestedPrice : ''
            },
            fleets: {
                coms1: [],
                coms2: [],
                coms3: [],
                coms4: [],
                coms5: [],
            },
            axiosConfig: {
                headers: {
                    'Authorization': `Bearer ${window.localStorage.getItem("token")}`,
                    'Accept': 'application/json'
                }
            },
        };
    },
    // watch: {
    //     searchQuery: {
    //         handler: debounce(function (newVal) {
    //             if (newVal.trim()) {
    //                 this.sendRequest(newVal);
    //             }
    //         }, 600), // 600ms بعد از آخرین تایپ
    //         immediate: false,
    //     },
    // },
    methods: {

        toggleDropdownTo(event) {
            event.target.select();
            this.showDropdownTo = !this.showDropdownTo;
            if (this.showDropdownTo == true) {
                this.showDropdownFrom = false;
            }
        },
        filterOptionsTo() {
            this.filteredOptionsTo = this.optionsTo.filter(option =>
                option.name.toLowerCase().includes(this.searchTo.toLowerCase())
            );
            this.showDropdownTo = true;
        },
        selectOptionTo(option) {
            this.showDropdownTo = false;
            // console.log(option);
            this.postData.toCityId = option.id;
            this.selectedTo = option;
            // // console.log(this.geoTo);
            this.searchTo = option.name + ' - ' + option.state;
            this.errors.toLoad = "";
        },
        selectOptionFrom(option) {
            this.postData.fromCityId = option.id;
            this.selectedFrom = option;
            this.searchFrom = `${option.name} - ${option.state}`;
            this.showDropdownFrom = false;
            this.errors.fromLoad = "";
        },
        filterOptionsFrom() {
            // this.filteredOptionsFrom = this.optionsFrom.filter(option =>
            //     `${option.name} ${option.state}`.toLowerCase().includes(this.searchFrom.toLowerCase())
            // );
            // this.showDropdownFrom = true;

            this.filteredOptionsFrom = this.optionsFrom.filter(option =>
                option.name.toLowerCase().includes(this.searchFrom.toLowerCase())
            );
            this.showDropdownFrom = true;
        },
        toggleDropdownFrom(event) {
            console.log(event);
            event.target.select();
            this.showDropdownFrom = !this.showDropdownFrom;
            if (this.showDropdownFrom == true) {
                this.showDropdownTo = false;
            }
        },
        getProvinceCities() {
            axios.get('https://core.iran-tarabar.ir/api/owner/provinceCities')
                .then(response => {
                    this.$cookies.set("citiesFrom", { data: response.data }, "1h");
                    this.optionsTo = response.data;
                    this.filteredOptionsTo = this.optionsTo;

                    this.optionsFrom = response.data;
                    this.filteredOptionsFrom = this.optionsFrom;
                })
                .catch(error => {
                    console.error('Error fetching data for destinations:', error);
                });
        },
        backFleet() {
            if (history.pushState) {
                var newurl = window.location.protocol + "//" + window.location.host + window.location.pathname + '?backFleet=1';
                window.history.pushState({ path: newurl }, '', newurl);
            }
        },
        changeTitleFleet(value) {
            this.selectedState = value;
        },
        // sendRequest(query) {
        //     console.log("ارسال ریکوئست با:", query);
        //     // اینجا axios یا fetch رو صدا بزن
        //     // axios.get(`/api/search?q=${query}`).then(...)
        // },
        calculatePrice() {
            // console.log(this.postData);
            this.price = 'در حال بررسی';
            axios.post("https://core.iran-tarabar.ir/api/driver/freightInquiry", this.postData, this.axiosConfig)
                .then((response) => {
                    if (response.data.data != null) {
                        this.price = response.data.data + " تومان ";
                    } else {
                        this.price = response.data.message;
                    }
                }).catch((error) => {
                    this.price = 'لطفا اینترنت خود را بررسی کنید'
                    console.log(error);
                });

            // if (!this.origin || !this.destination || !this.vehicle || !this.loader) {
            //     alert("لطفا تمام فیلدها را پر کنید.");
            //     return;
            // }
            // // نمونه محاسبه (شما می‌توانید این قسمت را تغییر دهید)
            // alert(
            //     `مبدا: ${this.origin}\nمقصد: ${this.destination}\nماشین: ${this.vehicle}\nبارگیر: ${this.loader}`
            // );
        },
        fleetDefault() {
            axios.get("https://core.iran-tarabar.ir/api/driver/fleetDefault", this.axiosConfig)
                .then((response) => {
                    this.postData.fleetId = response.data.id;
                    this.selectedState = response.data.title + ' (پیش فرض) '
                }).catch((error) => {
                    if (error.response.status === 401) {
                        Swal.fire({
                            title: "راننده محترم!",
                            text: "شماره ای که با آن وارد برنامه شده اید، توسط دستگاه دیگری مورد استفاده قرار گرفته است!",
                            icon: "error",
                            confirmButtonColor: "#068b80",
                            confirmButtonText: "ورود مجدد!",
                        }).then((result) => {
                            if (result.isConfirmed) {
                                localStorage.clear();
                                router.push({ name: 'login' })
                            }
                        });

                    }
                });
        },
        getFleets() {
            axios.get("https://core.iran-tarabar.ir/api/customer/requestAllFleetsLists")
                .then((response) => {
                    this.loading = false;
                    this.fleets.coms1 = response.data.fleets.filter(obj => obj.parent_id == 42);
                    this.fleets.coms2 = response.data.fleets.filter(obj => obj.parent_id == 43);
                    this.fleets.coms3 = response.data.fleets.filter(obj => obj.parent_id == 53);
                    this.fleets.coms4 = response.data.fleets.filter(obj => obj.parent_id == 54);
                    this.fleets.coms5 = response.data.fleets.filter(obj => obj.parent_id == 81);
                })
                .catch(() => {
                    // handle error
                    Swal.fire({
                        position: "center",
                        icon: "error",
                        title: "لطفا اینترنت خود را بررسی کنید",
                        showConfirmButton: true,
                        confirmButtonText: "تایید",
                    });
                });
        },
    },
    mounted() {
        this.getFleets();
        this.getProvinceCities();
        this.fleetDefault();
    }
}
</script>
<style scoped>
.form-box {
    background: #fff;
    border-radius: 12px;
    padding: 25px;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
    max-width: 420px;
    margin: 50px auto;
    direction: rtl;
    font-family: Tahoma, sans-serif;
}

.dropdown-scroll {
    max-height: 200px;
    /* تنظیم ارتفاع برای اسکرول */
    overflow-y: auto;
}

.btn-custom {
    background-color: #00b894;
    color: #fff;
    font-weight: bold;
    width: 100%;
    border-radius: 8px;
    padding: 12px;
}

.btn-custom:hover {
    background-color: #019874;
    color: #fff;
}

label {
    font-weight: bold;
    margin-bottom: 6px;
}
</style>
